/* ==========================================================================
   smellBgone accordion — single-open disclosure behaviour shared by the FAQ
   and DS accordion lists (ports app/components/brand/Accordion.tsx).

   Markup contract (so one behaviour serves both skins, which use different
   open-class names — FAQ ".open", DS ".is-open"):
     <div data-accordion="open|is-open">        <- list; value is the open class
       <div data-accordion-item>
         <button data-accordion-trigger aria-expanded="false">…</button>
         <div>…body…</div>
       </div>
     </div>
   Event-delegated on document so editor-injected sections work without re-init.
   ========================================================================== */
(function () {
  if (window.__smbAccordionInit) return;
  window.__smbAccordionInit = true;

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-accordion-trigger]');
    if (!trigger) return;
    var item = trigger.closest('[data-accordion-item]');
    var list = trigger.closest('[data-accordion]');
    if (!item || !list) return;

    var openClass = list.getAttribute('data-accordion') || 'is-open';
    var isOpen = item.classList.contains(openClass);

    // Single-open: close every item in this list first.
    list.querySelectorAll('[data-accordion-item]').forEach(function (it) {
      it.classList.remove(openClass);
      var t = it.querySelector('[data-accordion-trigger]');
      if (t) t.setAttribute('aria-expanded', 'false');
    });

    if (!isOpen) {
      item.classList.add(openClass);
      trigger.setAttribute('aria-expanded', 'true');
    }
  });
})();
